import React from 'react';
import clsx from 'clsx';
import { ADMINISTRATOR_COLOR, AGENCY_ADMIN_COLOR, AGENT_COLOR, BROKER_COLOR, FLEET_ADMIN_COLOR, FLEET_MANAGER_COLOR, FUEL_ADMIN_COLOR, FUEL_MANAGER_COLOR, FUEL_VENDOR_COLOR, INSURER_ADMIN_COLOR, INSURER_AGENT_COLOR, INSURER_CLAIM_ADMIN_COLOR, INSURER_FINANCE_ADMIN_COLOR, INSURER_MARKETING_ADMIN_COLOR, INSURER_POLICY_ADMIN_COLOR, INSURER_TECH_ADMIN_COLOR, INSURER_UNDERWRITER_COLOR, MANAGER_COLOR, REVIEWER_COLOR, RIDE_SHARING_ADMIN_COLOR, RIDE_SHARING_AGENT_COLOR, SUPER_ADMINISTRATOR_COLOR, SUPERVISOR_COLOR, TEAM_MANAGER_COLOR, TECHNICAL_COLOR, WORKSPACE_OWNER_COLOR } from '../../resources/constants';

interface IUsersStatusProps {
  status: string | null | boolean;
  classes?: string;
}

const UsersStatus: React.FC<IUsersStatusProps> = ({ status, classes, }) => {

  const statusClass = clsx(
    '!w-fit px-3 whitespace-nowrap  h-[24px] !rounded-full !text-xs gap-[2px] flex items-center justify-start text-sm',
    {

      [SUPER_ADMINISTRATOR_COLOR]: status === 'Super Administrator',
      [ADMINISTRATOR_COLOR]: status === 'Administrator',
      [INSURER_ADMIN_COLOR]: status === 'Insurer Super Admin',
      [INSURER_AGENT_COLOR]: status === 'Insurer Agent',
      [INSURER_TECH_ADMIN_COLOR]: status === 'Insurer Tech Admin',
      [INSURER_POLICY_ADMIN_COLOR]: status === 'Insurer Policy Admin',
      [INSURER_FINANCE_ADMIN_COLOR]: status === 'Insurer Finance Admin',
      [INSURER_CLAIM_ADMIN_COLOR]: status === 'Insurer Claim Admin',
      [INSURER_MARKETING_ADMIN_COLOR]: status === 'Insurer Marketing Admin',
      [INSURER_UNDERWRITER_COLOR]: status === 'Insurer Underwriter',
      [AGENCY_ADMIN_COLOR]: status === 'Agency Admin',
      [AGENT_COLOR]: status === 'Agent',
      [REVIEWER_COLOR]: status === 'Reviewer',
      [RIDE_SHARING_ADMIN_COLOR]: status === 'Ride Sharing Admin',
      [RIDE_SHARING_AGENT_COLOR]: status === 'Ride Sharing Agent',
      [FLEET_ADMIN_COLOR]: status === 'Fleet Admin',
      [FLEET_MANAGER_COLOR]: status === 'Fleet Manager',
      [FUEL_ADMIN_COLOR]: status === 'Fuel Admin',
      [FUEL_MANAGER_COLOR]: status === 'Fuel Manager',
      [FUEL_VENDOR_COLOR]: status === 'Fuel Vendor',
      [TECHNICAL_COLOR]: status === 'Technical',
      [BROKER_COLOR]: status === 'Broker',
      [TEAM_MANAGER_COLOR]: status === 'Team Manager',
      [MANAGER_COLOR]: status === 'Manager',
      [WORKSPACE_OWNER_COLOR]: status === 'Workspace Owner',
      [SUPERVISOR_COLOR]: status === 'Supervisor',

    },
    classes);

  const displayStatus = status !== null ? status : '-';

  return (
    <div className="w-full flex items-start">
      <div className={statusClass}> <span>{displayStatus}</span></div>
    </div>
  );
};

export default UsersStatus;
